import { NSARouterMakerResult } from "namirasoft-account-react";
import { FuelInputRow, FuelRow } from "namirasoft-erp";
import { NSBox, NSBoxString, NSBoxTextArea, NSColumn } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { ErpEntities } from "../ErpEntities";
import { ErpLayout } from '../ErpLayout';
import { ErpRouterProps } from "../ErpRouterProps";
import { ErpScope, ErpScopeField, ErpScopeMode } from "../ErpScope";

interface Props extends NSARouterMakerResult, ErpRouterProps { isEdit: boolean; }

export default class FuelEditPage extends Component<Props>
{
    Name = createRef<NSBoxString>();
    Description = createRef<NSBoxTextArea>();

    override render()
    {
        return (
            <ErpLayout<FuelRow, FuelInputRow>
                {...this.props}
                mode={ErpScopeMode.Select}
                fields={[ErpScopeField.Company, ErpScopeField.Branch]}
                pages={{
                    entity: ErpEntities.fuel(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): FuelInputRow => ({
                                        company_id: ErpScope.getCompanyId() ?? "",
                                        branch_id: ErpScope.getBranchId() ?? "",
                                        name: this.Name.current?.getValue() ?? "",
                                        description: this.Description.current?.getValue() ?? null,
                                        fuel_category: [],
                                        fuel_tag: [],
                                        fuel_field: [],
                                    }),
                                    setRow: (row: FuelRow) =>
                                    {
                                        ErpScope.set({ company_id: row.company_id, branch_id: row.branch_id });
                                        this.Name.current?.setValue(row.name);
                                        this.Description.current?.setValue(row.description);
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSBoxString ref={this.Name} required title="Name" style={{ width: NSBox.width.double }} />
                    <NSBoxTextArea ref={this.Description} required={false} title="Description" style={{ width: NSBox.width.double }} />
                </NSColumn>
            </ErpLayout>
        );
    }
}